import React, { useEffect, useState, useMemo } from "react";
import performanceOverview from "../../assets/performance-overview.png";
import cancellation from "../../assets/cancellation.png";
import customer from "../../assets/customers.png";
import revenue from "../../assets/revenue.png";
import growth from "../../assets/growth.png";
import commonapihandler from "../../common/commonapihandler";
import { getBookingKPI } from "../../api/api";
import { useSelector } from "react-redux";
import DaterangePicker from "../../common/Daterangepicker";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import toast from "react-hot-toast";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import { Search } from "lucide-react";
import InfoTooltip from "../../common/InfoTooltip";

const Kpianalytics = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [cityFilter, setCityFilter] = useState("1");
  const [kpiData, setKpiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  useEffect(() => {
    getKpiAPIData();
  }, []);

  function formatDateForApi(date, type) {
    if (!date) return "";
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  // const getKpiAPIData = async () => {
  //   const formattedStartDate = formatDateForApi(
  //     selectionRange?.startDate,
  //     "start",
  //   );
  //   const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
  //   const apiDetails = await getBookingKPI(
  //     formattedStartDate,
  //     formattedEndDate,
  //     cityFilter,
  //   );
  //   const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
  //   if (data) {
  //     setKpiData(data?.dataValues);
  //   }
  // };

  const getKpiAPIData = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query= "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/booking-dashboard-kpi?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setKpiData(data?.dataValues);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  const performanceOverviewData = {
    title: "Performance Overview",
    titleIcon: performanceOverview,
    counts: [
      {
        title: "Total Bookings",
        value: kpiData?.totalBookingCount || 0,
      },
      {
        title: "Doc / Ver Pending",
        value:
          kpiData?.documentPendingBookingCount +
            kpiData?.verificationPendingBookingCount || 0,
      },
      {
        title: "Closed",
        value: kpiData?.closedBookingCount || 0,
      },
      {
        title: "Booking Confirmed",
        value: kpiData?.confirmedBookingCount || 0,
      },
      {
        title: "En-route",
        value: kpiData?.enrouteBookingCount || 0,
      },
      {
        title: "Inquiry Conversion",
        value: kpiData?.inquiryConversionCount || 0,
      },
    ],
  };

  const cancellationOverviewData = {
    title: "Cancellation",
    titleIcon: cancellation,
    counts: [
      {
        title: "Cancelled",
        value: kpiData?.cancelledBookingCount || 0,
        outof: `Out of ${kpiData?.bookingCount || 0} bookings`,
      },
      {
        title: "Cancelled",
        value: kpiData?.cancelledBookingPercentage + "%" || 0,
        outof: "selected range",
      },
    ],
  };

  const customerOverviewData = {
    title: "Customers",
    titleIcon: customer,
    counts: [
      {
        title: "Repeat Customer Rate",
        value: kpiData?.repeatCustomerRate + "%" || 0,
        outof: "selected range",
      },
      // {
      //   title: "Conversion Count",
      //   value: kpiData?.inquiryConversionCount,
      //   outof: "Inquiry → Booking",
      // },
      {
        title: "Conversion Rate",
        value: kpiData?.inquiryConvertedRate + "%" || 0 ,
        outof: "Inquiry → Booking",
      },
    ],
  };

  const revenueOverviewData = {
    title: "Revenue & Value",
    titleIcon: revenue,
    counts: [
      // {
      //   title: "Total Revenue",
      //   value: 525 + " %",
      //   outof: "vs last period",
      // },
      {
        title: "Avg rev / Booking",
        value: kpiData?.averageRevenuePerBooking
          ? "₹ " + kpiData?.averageRevenuePerBooking
          : 0,
        outof: "Total rev ÷ No of bookings",
      },
      {
        title: "Avg Trip Duration",
        value: kpiData?.averageTripDuration + "%" || 0,
        outof: "per trip",
      },
      {
        title: "Total Revenue",
        value: "₹ " + kpiData?.totalRevenue || 0,
        outof: "on selected range",
      },
    ],
  };

  return (
    <>
      {loading ? (
        <DashboardSkeleton />
      ) : (
        <>
          {" "}
          <div className="w-full my-2 bg-white border-b border-[#E5E7EB] shadow-sm px-8 py-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 my-6 rounded-lg">
            <div className="flex items-center gap-3">
              <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
                KPI
              </h1>
              <InfoTooltip
                position="right"
                content={
                  <div className="space-y-1 text-xs">
                    <p>
                      <strong>Booking Revenue:</strong> Weekday Rent + Weekend
                      Rent − Discount
                    </p>
                    <p>
                      <strong>Trip Duration:</strong> (Book To − Book From)
                      / 24 hrs
                    </p>
                    <p>
                      <strong>Total Revenue:</strong> Weekday Rent + Weekend Rent - discountAmount
                    </p>
                    <p>
                      <strong>Total Actual Days Run:</strong> (Booking End Date - Booking Start Date) / (1000 * 60 * 60 * 24);
                    </p>
                    <p>
                      <strong>Average Trip Duration:</strong> Total Days Run ÷
                      Total Bookings
                    </p>
                    <p>
                      <strong>Average Revenue/Booking:</strong> Total Revenue ÷
                      Total Bookings
                    </p>
                    <p>
                      <strong>Utilization Rate:</strong> (Total Days Run ÷
                      (Fleet Size × Target Days)) × 100
                    </p>
                    <p>
                      <strong>Cancelled %:</strong> (Cancelled Bookings ÷ Total
                      Bookings) × 100
                    </p>
                    <p>
                      <strong>Repeat Customer Rate:</strong> (Repeat Customers ÷
                      Unique Customers) × 100
                    </p>
                    <p>
                      <strong>Inquiry Conversion Rate for admin:</strong> (Converted
                      Inquiries ÷ Admin Bookings) × 100
                    </p>
                    <p>
                      <strong>Total Bookings:</strong> Except Cancelled bookings all are included
                    </p>
                  </div>
                }
              />
            </div>

            <div className="flex gap-4 justify-end">
              <DaterangePicker
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                style={-10}
              />

              <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="flex-shrink-0 w-4 h-4"
                  >
                    <path
                      d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                      stroke="#99A1AF"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                      stroke="#99A1AF"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <Citiescommondropdown
                    value={cityFilter}
                    onChange={setCityFilter}
                    options={[
                      { value: null, label: "All Cities" },
                      ...cityOptions,
                    ]}
                    placeholder="City"
                    className="flex-1 min-w-[80px]"
                    showSearch={true}
                  />
                </div>
              </div>

              <button
                onClick={() => {
                  getKpiAPIData();
                }}
                className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <Search size={18} />
                Search
              </button>
            </div>
          </div>
          <div className="w-full max-w-[1600px] p-4 inline-flex flex-col justify-end items-center">
            <div className="self-stretch flex flex-col justify-center items-start gap-11">
              <div className="self-stretch px-1 pb-2 bg-slate-400/20 rounded-3xl flex flex-col justify-center items-center gap-6">
                <div className="self-stretch bg-[#9F8080] rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] flex justify-center items-center">
                    <div className="size-6 relative">
                      <img src={performanceOverviewData?.titleIcon} />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    {performanceOverviewData?.title}
                  </div>
                </div>
                <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
                  {performanceOverviewData?.counts &&
                    performanceOverviewData?.counts.map((data) => (
                      <div className="flex-1 h-36 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-start">
                        <>
                          <div className="self-stretch h-9 pb-4 inline-flex justify-center items-center">
                            <div className="text-[#696E79] text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                              {data?.title}
                            </div>
                          </div>
                          <div className="self-stretch h-14 flex flex-col justify-center items-center">
                            <div className="text-[#444] text-[42px] font-bold font-days leading-5 tracking-[0.4px]">
                              {data?.value}
                            </div>
                          </div>
                        </>
                      </div>
                    ))}
                </div>

                <div className="w-full h-40 my-4 bg-white rounded-2xl outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex justify-start items-center gap-2 overflow-hidden">
                  <div className="flex-1 self-stretch px-6 py-7 inline-flex flex-col justify-between items-start">
                    <div className="self-stretch h-20 flex flex-col justify-between items-start">
                      <div className="self-stretch inline-flex justify-between items-center">
                        <div className="justify-start text-zinc-500 text-xl font-semibold font-['Outfit'] leading-5">
                          Total Days Run Count
                        </div>
                        {/* <div className="text-right justify-start text-green-700 text-base font-semibold font-['Outfit'] leading-4">
                      Avg trip duration {kpiData?.averageTripDuration}
                    </div> */}
                      </div>
                      <div className="self-stretch inline-flex justify-start items-baseline gap-2">
                        <div className="justify-start text-gray-900 text-4xl font-normal font-['Days_One'] leading-10">
                          {kpiData?.totalActualDaysRun || 0}
                        </div>
                        <div className="justify-start text-gray-500 text-sm font-semibold font-['Outfit'] leading-5">
                          days
                        </div>
                      </div>
                    </div>
                    {/* <div className="self-stretch flex flex-col justify-start items-start gap-1.5">
                  <div className="self-stretch h-5 bg-gray-200 rounded-[999px] inline-flex justify-start items-start overflow-hidden">
                    <div className="w-96 self-stretch bg-green-700 rounded-[999px]" />
                  </div>
                  <div className="self-stretch inline-flex justify-between items-center">
                    <div className="justify-start text-gray-500 text-xs font-semibold font-['Outfit'] leading-4">
                      Growth
                    </div>
                    <div className="justify-start text-green-700 text-xs font-bold font-['Outfit'] leading-4">
                      +71%
                    </div>
                  </div>
                </div> */}
                  </div>
                  <div className="w-px h-44 bg-zinc-400"></div>
                  <div className="flex-1 self-stretch px-6 py-7 inline-flex flex-col justify-between items-start">
                    <div className="self-stretch h-20 flex flex-col justify-between items-start">
                      <div className="self-stretch inline-flex justify-between items-center">
                        <div className="justify-start text-zinc-500 text-xl font-semibold font-['Outfit'] leading-5">
                          Avg Vehicle Utilisation
                        </div>
                        {/* <div className="text-right justify-start text-green-700 text-base font-semibold font-['Outfit'] leading-4">
                      Average trip duration {kpiData?.averageTripDuration}
                    </div> */}
                      </div>
                      <div className="self-stretch inline-flex justify-start items-baseline gap-2">
                        <div className="justify-start text-gray-900 text-4xl font-normal font-['Days_One'] leading-10">
                          {kpiData?.utilizationRate + "%" || 0}
                        </div>
                        {/* <div className="justify-start text-gray-500 text-sm font-semibold font-['Outfit'] leading-5">
                          days
                        </div> */}
                      </div>
                    </div>
                    {/* <div className="self-stretch flex flex-col justify-start items-start gap-1.5">
                  <div className="self-stretch h-5 bg-gray-200 rounded-[999px] inline-flex justify-start items-start overflow-hidden">
                    <div className="w-[540px] self-stretch bg-blue-800 rounded-[999px]" />
                  </div>
                  <div className="self-stretch inline-flex justify-end items-center">
                    <div className="justify-start text-blue-900 text-xs font-bold font-['Outfit'] leading-4">
                    +2.2 days vs last period
                  </div>
                    <div className="justify-start text-green-700 text-xs font-bold font-['Outfit'] leading-4">
                      85%
                    </div>
                  </div>
                </div> */}
                  </div>
                </div>
              </div>

              <div className="self-stretch inline-flex justify-center items-center gap-4">
                <div className="w-[549px] px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-center items-center gap-6">
                  <div className="self-stretch bg-[#FF4242] rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                    <div className="self-stretch flex justify-start items-center gap-4">
                      <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-red-400 flex justify-center items-center">
                        <div className="size-6 relative">
                          <img src={cancellationOverviewData?.titleIcon} />
                        </div>
                      </div>
                      <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                        {cancellationOverviewData?.title}
                      </div>
                    </div>
                  </div>
                  <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
                    {cancellationOverviewData &&
                      cancellationOverviewData?.counts.map((data) => (
                        <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                          <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                            <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                              {data?.title}
                            </div>
                          </div>
                          <div className="self-stretch h-16 flex flex-col justify-center items-center">
                            <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                              {data?.value}
                            </div>
                          </div>
                          <div className="justify-center text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                            {data?.outof}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="w-px h-44 bg-zinc-400"></div>
                <div className="flex-1 px-1 pb-2 bg-yellow-600/20 rounded-3xl inline-flex flex-col justify-center items-center gap-6">
                  <div className="self-stretch bg-[#BC8426] rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                    <div className="self-stretch flex justify-start items-center gap-4">
                      <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-yellow-600 flex justify-center items-center">
                        <div className="w-7 h-6 relative">
                          <img src={customerOverviewData?.titleIcon} />
                        </div>
                      </div>
                      <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                        {customerOverviewData?.title}
                      </div>
                    </div>
                  </div>
                  <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
                    {customerOverviewData &&
                      customerOverviewData?.counts.map((data) => (
                        <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                          <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                            <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                              {data?.title}
                            </div>
                          </div>
                          <div className="self-stretch h-16 flex flex-col justify-center items-center">
                            <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                              {data?.value}
                            </div>
                          </div>
                          <div className="justify-center text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                            {data?.outof}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="self-stretch px-1 pb-2 bg-neutral-500/20 rounded-3xl flex flex-col justify-center items-center gap-6">
                <div className="self-stretch bg-blue-400 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                  <div className="self-stretch flex justify-start items-center gap-4">
                    <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                      <div className="size-6 relative overflow-hidden">
                        <img src={revenueOverviewData?.titleIcon} />
                      </div>
                    </div>
                    <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                      {revenueOverviewData?.title}
                    </div>
                  </div>
                </div>
                <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
                  {revenueOverviewData &&
                    revenueOverviewData?.counts.map((data) => (
                      <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                        <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                          <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                            {data?.title}
                          </div>
                        </div>
                        <div className="self-stretch h-16 flex flex-col justify-center items-center">
                          <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                            {data?.value}
                          </div>
                        </div>
                        <div className="justify-start text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                          {data?.outof}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              {/* <div className="self-stretch px-1 pb-2 bg-slate-400/20 rounded-3xl flex flex-col justify-center items-center gap-6">
          <div className="self-stretch bg-green-500 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
            <div className="self-stretch flex justify-start items-center gap-4">
              <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-teal-900 flex justify-center items-center">
                <div className="size-6 relative overflow-hidden">
                  <img src={growth} />
                </div>
              </div>
              <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                Growth
              </div>
            </div>
          </div>
          <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-4">
            <div className="size- p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                  Booking growth vs previous period
                </div>
              </div>
              <div className="self-stretch h-16 flex flex-col justify-center items-center">
                <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  18%
                </div>
              </div>
              <div className="justify-start text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                vs last period
              </div>
            </div>
            <div className="flex-1 self-stretch inline-flex flex-col justify-center items-center gap-4">
              <div className="self-stretch inline-flex justify-between items-start">
                <div className="justify-start text-slate-500 text-xl font-normal font-['Outfit'] leading-5">
                  Pervious
                </div>
                <div className="justify-start text-slate-500 text-xl font-normal font-['Outfit'] leading-5">
                  Current
                </div>
              </div>
              <div className="size- inline-flex justify-start items-center gap-2.5">
                <div className="w-[464px] h-4 bg-zinc-300 rounded-2xl flex justify-start items-center gap-0.5">
                  <div className="w-80 h-4 bg-indigo-700 rounded-2xl" />
                </div>
                <div className="justify-start text-neutral-700 text-base font-bold font-['Inter'] leading-5">
                  68%
                </div>
              </div>
              <div className="self-stretch inline-flex justify-between items-start">
                <div className="justify-start text-slate-500 text-xl font-normal font-['Outfit'] leading-5">
                  445 bookings
                </div>
                <div className="justify-start text-slate-500 text-xl font-normal font-['Outfit'] leading-5">
                  525 bookings
                </div>
              </div>
            </div>
            <div className="w-60 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch h-16 flex flex-col justify-center items-start">
                <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  +80
                </div>
              </div>
              <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                  Bookings
                </div>
              </div>
              <div className="justify-start text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                net new this period
              </div>
            </div>
          </div>
        </div> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Kpianalytics;
